<template>
  <div class="inquiry-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-btn" @click="returnToFrontPage">
        <a-icon type="left" /> 返回
      </div>
      <h3>{{ currentTitle }}</h3>
    </div>
      <div class="list-container">
        <div class="order-list">
          <div
              class="order-item"
              v-for="(item, index) in dataList"
              :key="index"
          >
            <div class="order-content">
              <div class="order-row">
                <span class="label">项目名称：</span>
                <span class="value">{{ item.monitorpointname }}</span>
              </div>
              <div class="order-row">
                <span class="label">附件：</span>
                <span class="value">
                  <a-button
                    v-if="item.file_url"
                    type="link"
                    size="small"
                    @click="previewFile(item.file_url)"
                  >
                    {{ getFileName(item.file_url) }}
                  </a-button>
                  <span v-else>无</span>
                </span>
              </div>
              <div class="order-row">
                <span class="label">备注：</span>
                <span class="value">{{ item.remark }}</span>
              </div>
            </div>
        </div>
      </div>
    </div>

    <!-- PDF 附件预览弹窗 -->
    <a-modal
      :visible="fileVisible"
      title="附件预览"
      :footer="null"
      width="90%"
      :bodyStyle="{ padding: '8px' }"
      @cancel="fileVisible = false"
    >
      <div style="height: 70vh;">
        <object
          :key="currentFileUrl"
          :data="currentFileUrl"
          type="application/pdf"
          style="width: 100%; height: 100%; border: none;"
        >
          <div style="text-align: center; padding-top: 30vh;">
            <p style="color: #999; margin-bottom: 16px;">无法内嵌预览，请点击下方按钮在新窗口查看</p>
            <a :href="currentFileUrl" target="_blank">
              <a-button type="primary">在新窗口打开</a-button>
            </a>
          </div>
        </object>
      </div>
    </a-modal>
  </div>
</template>
<script>

import {getProjectOverviewByCondition} from "A/thjlcx";

export default {
  name: "projectOverview" ,
  components: {},
  data() {
    return {
      dataList:[],
      fileVisible: false,
      currentFileUrl: '',
      baseUrl: 'https://fda.u-lake.com/',
    }
  },
  computed:{
    currentTitle() {
      return '项目概况';
    }
  },
  created() {
    this.getDataList(this.$store.state.monitorpointnum)
  },
  methods:{
    getDataList(monitorpointnum){
      this.showLoading();
      getProjectOverviewByCondition({monitorpointnum:monitorpointnum}).then(res => {
        this.hideLoading();
        if(res&&res.returncode==='0'){
          this.dataList = res.item;
        }
      })
    },
    returnToFrontPage() {
      this.$router.back();
    },
    getFileName(url) {
      if (!url) return '';
      const parts = url.toString().split('/');
      return parts[parts.length - 1] || url;
    },
    previewFile(url) {
      const fullUrl = url.startsWith('http') ? url : this.baseUrl + url;
      this.currentFileUrl = fullUrl;
      this.fileVisible = true;
    },
  }
}
</script>
<style scoped lang="scss">
.inquiry-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

/* 顶部导航 */
.header {
  background: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .back-btn {
    color: #1890ff;
    font-size: 16px;
    cursor: pointer;
    margin-right: auto;
    display: flex;
    align-items: center;
  }

  h3 {
    margin: 0;
    font-weight: 600;
    color: #333;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
  }
}
/* 列表容器 */
.list-container {
  background: #fff;
  margin: 10px;
  padding: 16px;
  border-radius: 8px;

  .list-header {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 16px;
  }
}

/* 工单列表项 */
.order-list {
  .order-item {
    padding: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    margin-bottom: 12px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .order-content {
      .order-row {
        display: flex;
        margin-bottom: 4px;
        font-size: 14px;

        .label {
          color: #999;
          min-width: 80px;
        }

        .value {
          flex: 1;
          color: #333;

          :deep(.ant-btn) {
            padding-left: 0;
            text-align: left;
          }
        }
      }
    }

    .order-status {
      position: absolute;
      right: 12px;
      top: 12px;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;

      &.status-waiting { background: #fffbe6; color: #faad14; }
      &.status-processing { background: #e6f7ff; color: #1890ff; }
      &.status-completed { background: #f6ffed; color: #52c41a; }
      &.status-warning { background: #fff2e8; color: #fa8c16; }
      &.status-reject { background: #fff2f0; color: #ff4d4f; }
      &.status-third { background: #f9f0ff; color: #722ed1; }
      &.status-plan { background: #e6f7ff; color: #13c2c2; }
      &.status-delay { background: #fffbe6; color: #faad14; }
      &.status-close { background: #f0f0f0; color: #666; }
      &.status-default { background: #f0f0f0; color: #666; }
    }
  }
}
</style>
